module.exports = __webpack_public_path__ + "img/image_part_008.06f2653e.jpg";